import { render } from "./NewsReleaseAdd.vue?vue&type=template&id=f1f5c270"
import script from "./NewsReleaseAdd.vue?vue&type=script&lang=js"
export * from "./NewsReleaseAdd.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Working\\GLMA\\baik\\baicpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__